import { render, staticRenderFns } from "./ProjectSetting.vue?vue&type=template&id=16b97360&scoped=true&"
import script from "./ProjectSetting.vue?vue&type=script&lang=js&"
export * from "./ProjectSetting.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSetting.vue?vue&type=style&index=0&id=16b97360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b97360",
  null
  
)

export default component.exports